import { motion } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { ArrowRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const TARJETAS = [
  {
    titulo: "TEMPORADA BAJA",
    precio: "$9,500",
    detalle: "PARA 20 PERSONAS",
    extra: "$400.00 POR PERSONA EXTRA",
    incluye: ["2 PERSONAS SERVICIO BLANCOS"],
  },
  {
    titulo: "TEMPORADA ALTA",
    precio: "$10,500",
    detalle: "PARA 20 PERSONAS",
    extra: "$400.00 POR PERSONA EXTRA",
    incluye: ["2 PERSONAS SERVICIO BLANCOS"],
  },
  {
    titulo: "SÁBADO A DOMINGO",
    precio: "$13,000",
    detalle: "PARA 20 PERSONAS",
    extra: "$400.00 POR PERSONA EXTRA",
    incluye: ["2 PERSONAS SERVICIO BLANCOS", "ENTRADA 10:00 AM", "SALIDA 04:00 PM"],
  },
];

const CONTACTO_NOTAS = [
  "*Precios por noche.",
  "*En fechas como Semana Santa, Navidad y Año Nuevo el mínimo de hospedaje es de 6 noches.",
  "*Alberca climatizada con paneles solares.",
  "(Opcional *El gas para alberca tiene costo adicional).",
];

export default function Precios() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className="py-28 md:py-40 px-6 lg:px-10 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1 }}
            className="text-accent text-sm tracking-[0.3em] uppercase font-light mb-6 block"
          >
            Tarifas
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.1 }}
            className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light text-foreground text-balance"
          >
            Elige tu estancia
          </motion.h2>
        </div>

        {/* 3 tarjetas principales */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-12">
          {TARJETAS.map((card, i) => (
            <motion.div
              key={card.titulo}
              initial={{ opacity: 0, y: 40 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1, delay: 0.2 + i * 0.1 }}
              className="flex flex-col bg-card border border-border rounded-sm overflow-hidden hover:border-accent/40 transition-colors duration-500"
            >
              <div className="bg-secondary/40 px-8 py-6 text-center border-b border-border">
                <h3 className="text-xs tracking-[0.3em] uppercase font-light text-muted-foreground mb-4">
                  {card.titulo}
                </h3>
                <div className="flex items-baseline justify-center gap-2">
                  <span className="font-serif-display text-5xl font-light text-foreground">
                    {card.precio}
                  </span>
                  <span className="text-sm font-light text-muted-foreground">MXN</span>
                </div>
              </div>

              <div className="flex-1 px-8 py-8 space-y-5">
                <p className="text-center text-xs tracking-[0.2em] uppercase font-light text-foreground/70">
                  {card.detalle}
                </p>
                <p className="text-center text-xs font-light text-muted-foreground">
                  {card.extra}
                </p>
                <div className="pt-4 border-t border-border">
                  <p className="text-xs tracking-[0.2em] uppercase font-light text-accent mb-3">
                    Incluye
                  </p>
                  <ul className="space-y-2">
                    {card.incluye.map((line) => (
                      <li
                        key={line}
                        className="text-sm font-light text-foreground/80 flex items-center gap-2"
                      >
                        <span className="w-1 h-1 rounded-full bg-accent flex-shrink-0" />
                        {line}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Botón flecha al calendario */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, delay: 0.5 }}
          className="flex justify-center mb-16"
        >
        </motion.div>

        {/* Tarjeta de contacto */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, delay: 0.6 }}
          className="bg-secondary/30 border border-border rounded-sm px-8 md:px-12 py-10 max-w-3xl mx-auto"
        >
          <div className="flex items-center justify-center gap-3 mb-8">
            <Phone size={20} strokeWidth={1.5} className="text-accent" />
            <h3 className="font-serif-display text-2xl md:text-3xl font-light text-foreground text-center">
              Contáctanos
            </h3>
          </div>
          <ul className="space-y-4 max-w-xl mx-auto">
            {CONTACTO_NOTAS.map((nota) => (
              <li
                key={nota}
                className="text-sm md:text-base font-light text-foreground/70 leading-relaxed text-center"
              >
                {nota}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}